import { render, staticRenderFns } from "./RuleGroupSearchModal.vue?vue&type=template&id=72ddb7fd&"
import script from "./RuleGroupSearchModal.vue?vue&type=script&lang=js&"
export * from "./RuleGroupSearchModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports